import {
  Primitive,
  useLayoutEffect2
} from "./chunk-D6QHF2UO.mjs";

// ../../node_modules/.pnpm/@radix-ui+react-portal@1.1.9_@types+react-dom@19.2.3_@types+react@19.2.14__@types+react_1cce15ec7b8f692335f3eff7d631e14a/node_modules/@radix-ui/react-portal/dist/index.mjs
import * as React from "react";
import ReactDOM from "react-dom";
import { jsx } from "react/jsx-runtime";
var PORTAL_NAME = "Portal";
var Portal = React.forwardRef((props, forwardedRef) => {
  const { container: containerProp, ...portalProps } = props;
  const [mounted, setMounted] = React.useState(false);
  useLayoutEffect2(() => setMounted(true), []);
  const container = containerProp || mounted && globalThis?.document?.body;
  return container ? ReactDOM.createPortal(/* @__PURE__ */ jsx(Primitive.div, { ...portalProps, ref: forwardedRef }), container) : null;
});
Portal.displayName = PORTAL_NAME;

export {
  Portal
};
//# sourceMappingURL=chunk-RRWBFD4V.mjs.map